const routeRoutes = {
  home: "/",
  auth: {
    login: "/login",
    resetPassword: "/reset-password",
    firstLogin: "/first-login",
  },
  settings: {
    page: "/settings",
    rolesAndPermission: "/settings/roles",
  },
  admin: {
    dashboard: `${(process.env.REACT_APP_OMANA_URL || "").replace(
      /\/?api\/?$/,
      ""
    )}/admin/dashboard`,
  },

  company: {
    form: "/company/form",
  },
  users: {
    list: "/users",
    edit: "/users/form/:userId",
    add: "/users/form/new",
    profile: "/users/form/me",
  },
  workspaces: {
    list: "/workspaces",
    item: "/workspace/:workspaceId",
    createWorkspace: "/workspaces/form/new",
    edit: "/workspaces/edit/:workspaceId",
  },
  meetings: {
    add: "/meetings/form/new",
    edit: "/meetings/form/edit/:meetingId",
    item: "/meeting/:meetingId",
    liveItem: "/meeting/live/:meetingId",
    offline: "/meeting/offline/:meetingId",
    summaryItem: "/meeting/:meetingId/summary",
    archive: "/meetings/archive",
    invitations: {
      presenceByMail: "/meetings/presenceByMail/:meetingId/:userId",
      reviewersByMain: "/meetings/approveByMail/:meetingId/:userId",
    },
  },
  calendar: "/calendar",
  archive: "/meetings/archive",
  documents: "/documents",
  messages: "/messages",
  votings: {
    add: "/votings/form/add",
    item: "/voting/:votingId",
    list: "/votings",
    edit: "/votings/form/edit/:votingId",
    liveItem: "/voting/live/:votingId",
    offlineItem: "/voting/offline/:votingId",
    summaryItem: "/voting/:votingId/summary",
  },
  tasks: {
    list: "/tasks",
    item: "/task/:taskId",
    globalItem: "/task/global/:taskId",
    add: "/tasks/form/new",
    edit: "/tasks/edit/:taskId",
  },
};

export default routeRoutes;
